import gql from 'graphql-tag';

export const SUBMIT_SCHOLARSHIP_INTERVIEW_RESULT = gql`
  mutation ($applicationId: String!) {
    submitScholarshipInterviewResult(applicationId: $applicationId)
  }
`;
